module.exports = __webpack_public_path__ + "static/img/26-3.ded9539.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/26-3.jpg
// module id = JvAM
// module chunks = 0